module.exports = __webpack_public_path__ + "static/img/fluid-buffer_256.dc33a4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fluid-buffer_256.png
// module id = NBXI
// module chunks = 0